import React from 'react';
import { Link } from 'react-router-dom';
import LoginPage from '../modules/auth/pages/login/LoginPage';
import ForgotPassword from '../modules/auth/pages/forgot-password/ForgotPassword';
import { CurrentVariant } from './variants';

const overrides = {
  login: {
    page: {
      logo: (): React.ReactElement => (
        <img className="logo" src={CurrentVariant.logo} alt="bankvault-logo" />
      ),
      text: CurrentVariant.loginText,
    },
  },
  'login-override-page': (): React.ReactElement => <LoginPage />,
  'forgot-password-override-page': (): React.ReactElement => <ForgotPassword />,
  sidemenu: {
    logo: (): React.ReactElement => (
      <div className="dash-logo">
        <img src={CurrentVariant.logo} alt="bankvault-logo" />
      </div>
    ),
  },
  'get-user-info': 'auth/user/me',
  'breadcrumb-home-item': (): React.ReactElement => (
    <Link key="linkHome" to="/" className="breadcrumb-item">
      Home
    </Link>
  ),
  'no-config-model': (): React.ReactElement | null => null,
  'no-account-topbar': (): React.ReactElement | null => null,
  // card: {
  //   image: () => (
  //     <img
  //       src={CurrentVariant.cardFront}
  //       style={{ width: '100%', height: 'auto' }}
  //       alt="card"
  //     />
  //   )
  // }
};

export default overrides;
